export default __webpack_public_path__ + "static/media/ooc-deception-example.88c4f1bf.webp";